import { Box, Link, type Theme, styled, useTheme } from "@mui/material";

import SocialMediaIcons from "./SocialMediaIcons";
import type { SocialMediaItem } from "../../types";

const LinkStyled = styled(Link)(({ theme }: { theme: Theme }) => ({
  color: theme.palette.text.primary,
  [theme.breakpoints.between("xs", "sm")]: {
    padding: "20px",
    backgroundColor: "#171717",
    borderRadius: "32px",
    "& svg": {
      fontSize: "24px",
    },
  },
}));

const styles = {
  container: (isRow: boolean) => ({
    display: "flex",
    flexDirection: isRow ? "row" : "column",
    gap: isRow ? "16px" : "8px",
  }),
  item: {
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    gap: "8px",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
  },
};

interface SocialMediaListProps {
  readonly socialMedia: SocialMediaItem[];
  readonly isPropertyInfoCard?: boolean;
}

export default function SocialMediaList(props: SocialMediaListProps) {
  const theme = useTheme();
  const { socialMedia, isPropertyInfoCard = false } = props;
  const sortedSocialMedia = socialMedia.toSorted((a, b) => a.id - b.id);
  return (
    <Box>
      <Box sx={styles.container(isPropertyInfoCard)}>
        {sortedSocialMedia.map((item) => {
          const socialMediaName = item.name.toLowerCase();
          const socialMediaId = `socialMedia_${item.id}`;
          return (
            <Box key={socialMediaId} sx={styles.item}>
              <LinkStyled href={item.url} target="_blank" sx={styles.iconContainer}>
                <SocialMediaIcons title={socialMediaName} color={theme.palette.neutral.main} fontSize="16px" />
              </LinkStyled>
              {!isPropertyInfoCard && (
                <LinkStyled href={item.url} key={socialMediaId} target="_blank">
                  {item.name}
                </LinkStyled>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
